import { useEffect, useMemo, useState } from "react";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useDispatch } from "react-redux";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useLocation, useNavigate } from "react-router-dom";
import { setLoading } from "../../core/feature/config/configSlice";
import Config from "../../config/Config";
import userIcon from "../../assets/images/icon_profile/user.svg";
import { getDataMedicalRecord } from "../../core/service/api_medical_record";
import HealthIcon from "../medicalRecordDetailReportComponent/mappingHealthIcon";
const ReportStudent = (props: any) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [dataUser, setDataUser] = useState([]);

  const env = Config.BaseUrlDev;

  const navigate = useNavigate();

  const dateFormatter = (dateStr: string) =>
    new Date(dateStr).toLocaleDateString("id-ID", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });

  const idPatient =
    location.state?.data?.[0]?.id || localStorage.getItem("accountId");

  const query = useMemo(() => {
    return idPatient ? `?idPatient=${String(idPatient).trim()}` : "";
  }, [idPatient]);

  const [latestData, setLatestdata] = useState<any | null>(null);
  const [historyData, setHistorydata] = useState<any[]>([]);

  useEffect(() => {
    if (idPatient) {
      fetchMedical();
    }
  }, [idPatient]);

  useEffect(() => {
    if (Array.isArray(dataUser) && dataUser.length > 0) {
      const sorted = [...dataUser].sort(
        (a, b) =>
          new Date((b as any).createdAt).getTime() -
          new Date((a as any).createdAt).getTime()
      );
      setLatestdata(sorted[0] as any);
      setHistorydata(sorted.slice(1) as any[]);
    }
  }, [dataUser]);

  const fetchMedical = async () => {
    try {
      dispatch(setLoading(true));
      const res = await getDataMedicalRecord(query);
      console.log("data rekam medis:", res.data);
      setDataUser(res.data || []);
    } catch (error) {
      console.error("gagal ambil data rekam medis:", error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }

  return (
    <>
      <div className="relative min-h-screen h-full z-50 bg-psp-primary pb-10">
        <div className="min-h-screen h-full mb-6 px-4 py-6 bg-psp-primary top-to-bottom">
          <section className="mt-1 flex flex-col gap-3">
            <h3 className="mb-2">
              <strong>Kondisi Terakhir Rekam Medis</strong>
            </h3>
            {latestData && (
              <div
                className="flex flex-row z-10 h-24 bg-white w-full rounded-3xl"
                onClick={() =>
                  navigate(`/medical-record/report/${latestData.id}`, {
                    state: { data: latestData },
                  })
                }
              >
                <div className="relative w-20 h-20 bg-gray-200 my-auto rounded-xl ml-3">
                  {latestData.photoUrl ? (
                    <img
                      src={getImgContent(latestData.photoUrl)}
                      alt=""
                      className="relative w-20 object-cover h-20"
                    />
                  ) : (
                    <img
                      src={userIcon}
                      alt=""
                      className="w-20 p-1 object-cover h-20"
                    />
                  )}
                </div>
                <div className="flex flex-row justify-between w-full">
                  <div className="flex flex-col px-3 justify-center">
                    <h1
                      className={`font-montserrat m-0 font-medium text-sm ${
                        latestData.active ? "text-black" : "text-gray-500"
                      }`}
                    >
                      {latestData.patientName?.length > 15
                        ? latestData.patientName.slice(0, 16) + "..."
                        : latestData.patientName ?? "-"}
                    </h1>
                    <h1
                      style={{ fontSize: 11 }}
                      className={`font-montserrat m-0 font-normal ${
                        latestData.active ? "text-black" : "text-gray-500"
                      }`}
                    >
                      NIS: {latestData.callerId}
                    </h1>
                    <h1
                      className={`font-montserrat m-0 font-medium text-sm ${
                        latestData.active ? "text-black" : "text-gray-500"
                      }`}
                    >
                      {dateFormatter(latestData.createdAt)}
                    </h1>
                  </div>
                  <div className="flex flex-col justify-center items-center pr-4 mt-3">
                    <HealthIcon size={48} score={latestData.healthScore} />
                    <p className="text-center text-gray-400">
                      {latestData.healthStatus}
                    </p>
                  </div>
                </div>
              </div>
            )}
            <h3 className="mb-2 mt-3">
              <strong>Riwayat Rekam Medis</strong>
            </h3>
            {historyData.map((item) => (
              <div
                key={item.id}
                className="flex flex-row z-10 h-24 bg-white w-full rounded-3xl"
                onClick={() =>
                  navigate(`/medical-record/report/${item.id}`, {
                    state: { data: item },
                  })
                }
              >
                <div className="relative w-20 h-20 bg-gray-200 my-auto rounded-xl ml-3">
                  {item.photoUrl ? (
                    <img
                      src={getImgContent(item.photoUrl)}
                      alt=""
                      className="relative w-20 object-cover h-20"
                    />
                  ) : (
                    <img
                      src={userIcon}
                      alt=""
                      className="w-20 p-1 object-cover h-20"
                    />
                  )}
                </div>
                <div className="flex flex-row justify-between w-full">
                  <div className="flex flex-col px-3 justify-center">
                    <h1
                      className={`font-montserrat m-0 font-medium text-sm ${
                        item.active ? "text-black" : "text-gray-500"
                      }`}
                    >
                      {item.patientName?.length > 15
                        ? item.patientName.slice(0, 16) + "..."
                        : item.patientName ?? "-"}
                    </h1>
                    <h1
                      style={{ fontSize: 11 }}
                      className={`font-montserrat m-0 font-normal ${
                        item.active ? "text-black" : "text-gray-500"
                      }`}
                    >
                      NIS: {item.callerId}
                    </h1>
                    <h1
                      className={`font-montserrat m-0 font-medium text-sm ${
                        item.active ? "text-black" : "text-gray-500"
                      }`}
                    >
                      {dateFormatter(item.createdAt)}
                    </h1>
                  </div>
                  <div className="flex flex-col justify-center items-center pr-4 mt-3">
                    <HealthIcon size={48} score={item.healthScore} />
                    <p className="text-center text-gray-400">
                      {item.healthStatus}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </section>
        </div>
      </div>
    </>
  );
};

export default ReportStudent;
